import { render, staticRenderFns } from "./SuggestedSetSkills.vue?vue&type=template&id=4d2ad0a7&scoped=true&"
import script from "./SuggestedSetSkills.vue?vue&type=script&lang=js&"
export * from "./SuggestedSetSkills.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedSetSkills.vue?vue&type=style&index=0&id=4d2ad0a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ad0a7",
  null
  
)

export default component.exports